<template>
  <div class="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
    <RfStatsCard
      title="Total users"
      :loading="props.loading"
      :value="toLocaleNumberString(props.users.curr)"
      :grow="~~calcDiff(props.users.curr, props.users.last)"
      :icon="RfPersonIcon"
      :timePeriod="timePeriod"
    />
    <RfStatsCard
      title="Total impressions"
      :loading="props.loading"
      :value="toLocaleNumberString(props.impressions.curr)"
      :grow="~~calcDiff(props.impressions.curr, props.impressions.last)"
      :icon="RfVisibilityIcon"
      :timePeriod="timePeriod"
    />
    <RfStatsCard
      title="Total clicks"
      :loading="props.loading"
      :value="toLocaleNumberString(props.clicks.curr)"
      :grow="~~calcDiff(props.clicks.curr, props.clicks.last)"
      :icon="RfWebTrafficIcon"
      :timePeriod="timePeriod"
    />
    <RfStatsCard
      title="Average CTR"
      :loading="props.loading"
      :value="`${props.ctr.curr}%`"
      :grow="~~calcDiff(+props.ctr.curr, +props.ctr.last)"
      :icon="RfConversionPathIcon"
      :timePeriod="timePeriod"
    />
  </div>
</template>

<script setup>
import RfStatsCard from "@/components/cards/RfStatsCard.vue";
import MetricsUtils from "@/utils/MetricsUtils";
import { toLocaleNumberString } from "@/utils/stringHelpers";
import RfPersonIcon from "@/components/icons/RfPersonIcon.vue";
import RfVisibilityIcon from "@/components/icons/RfVisibilityIcon.vue";
import RfWebTrafficIcon from "@/components/icons/RfWebTrafficIcon.vue";
import RfConversionPathIcon from "@/components/icons/RfConversionPathIcon.vue";

const calcDiff = (v2, v1) => (!v2 && !v1 ? 0 : ((v2 - v1) / v1) * 100);

const props = defineProps({
  users: { type: Object, default: () => ({ curr: 0, last: 0 }) },
  impressions: { type: Object, default: () => ({ curr: 0, last: 0 }) },
  clicks: { type: Object, default: () => ({ curr: 0, last: 0 }) },
  ctr: { type: Object, default: () => ({ curr: 0, last: 0 }) },
  timePeriod: { type: String, default: MetricsUtils.All_Periods[0].value },
  loading: { type: Boolean, default: true },
});
</script>
